import React from 'react';
import { useBuild } from '../contexts/BuildContext';
import EnrichedResultsColumn2 from './EnrichedResultsColumn2';


const EnrichedResultsColumn = () => {
  const { hits, isLoading } = useBuild();
  return <EnrichedResultsColumn2 hits={hits} isLoading={isLoading} />;
};


export default EnrichedResultsColumn;

